import { useEffect, useState } from 'react';

// Captured once per page load (module init) — this is "time since this
// portal page was opened," not the login timestamp. Deliberately not wired
// to customer-auth.store.ts's login moment, so this hook never needs to
// touch — or risk regressing — Phase 1 auth state.
const SESSION_START_MS = Date.now();

function formatDuration(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60);
    const remMinutes = minutes % 60;
    return `${hours}h ${remMinutes}m`;
  }
  if (minutes === 0) return `${seconds}s`;
  return `${minutes}m ${seconds}s`;
}

/** Current-portal-session elapsed time, labeled clearly by the caller as such — not a real SLA/uptime metric. */
export function useCustomerSessionDuration(): string {
  const [label, setLabel] = useState(() => formatDuration(Date.now() - SESSION_START_MS));

  useEffect(() => {
    const timer = setInterval(() => {
      setLabel(formatDuration(Date.now() - SESSION_START_MS));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return label;
}
